<template>
    <b-col>
        <b-button
            v-show="!isRunning"
            v-b-modal.modal-importer-input
            variant="secondary"
            >Importar de Nível Reservartório</b-button
        >
        <modal-importer
            id="modal-importer-input"
            :source="source"
            @import-data="importData"
        >
            <template #default="{ data }">
                <b-form-group label="Cota montante">
                    <b-input-group append="m">
                        <swx-number-input
                            :value="data.quota_flux"
                            name="quota_flux"
                            disabled
                        />
                    </b-input-group>
                </b-form-group>
            </template>
        </modal-importer>
    </b-col>
</template>

<script>
import sleep from "@/utils/sleep";
import ModalImporter from "@/modules/simulator/components/ModalImporter";
import SwxNumberInput from "@/components/SwxNumberInput";
import { Status } from "@/modules/simulator/store";
import { SOURCE } from "@/modules/campos_novos/settings";

export default {
    name: "ReservoirInfoImporter",
    components: {
        ModalImporter,
        SwxNumberInput
    },
    computed: {
        source() {
            return SOURCE;
        },
        status() {
            return this.$store.state.campos_novos.simulator.status;
        },
        isRunning() {
            return this.status === Status.running;
        }
    },
    methods: {
        async importData({ data, callback }) {
            await sleep(1000);
            await this.$store.dispatch(
                "campos_novos/simulator/updateFromReservorInfo",
                data
            );

            callback();
        }
    }
};
</script>
